import React from 'react';
import Image from 'gatsby-plugin-sanity-image';

export const BlogImage = ({ mainImage }) => {
  return (
    mainImage && mainImage.asset && <Image {...mainImage} className="w-full" />
  );
};
